import { render, staticRenderFns } from "./manufacturerWarnList.vue?vue&type=template&id=06d9cf37"
import script from "./manufacturerWarnList.vue?vue&type=script&lang=js"
export * from "./manufacturerWarnList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports